/*----------------------------------------------------------------------------*\
 MODAL
 Opening and closing an accessible modal, as per https://github.com/gdkraus/accessible-modal-dialog
 \*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */



/*  Component
 \*----------------------------------------------------------------------------*/

oy.modal = {
    $mainPage: document.querySelector('.js--main-page'),
    $modalOverlay: document.querySelector('.js--modal-overlay'),
    $modals: document.querySelectorAll('.js--modal'),
    $triggersOpenModal: document.querySelectorAll('.js--open-modal'),
    $triggersCloseModal: document.querySelectorAll('.js--close-modal'),
    focusableElementsString: 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]',
    // store the item that has focus before opening the modal window
    focusedElementBeforeModal: null,
    $activeModal: null,

    init: function () {
        if (oy.cutsMustard) {
            this.initModal(document);
        }
    },

    initModal: function ($context) {
        var self = this;

        self.moveModals($context);

        // bind clicks to open modal
        for (var i = 0; i < self.$triggersOpenModal.length; ++i) {
            var $openTrigger = self.$triggersOpenModal[i];
            $openTrigger.addEventListener('click', function () {
                var $modalID = this.dataset.modalId;
                self.openModal($context, $modalID);
            });
        }

        // bind clicks to close modal
        for (var j = 0; j < self.$triggersCloseModal.length; ++j) {
            var $closeTrigger = self.$triggersCloseModal[j];
            $closeTrigger.addEventListener('click', function () {
                var $modalID = this.dataset.modalId;
                self.closeModal($context, $modalID);
            });
        }
    },

    // move modals to the page, outside of .js--main-page
    moveModals: function ($context) {
        var self = this;
        for (var i = 0; i < self.$modals.length; ++i) {
            $context.querySelector('body').appendChild(self.$modals[i]);
        }
    },

    openModal: function ($context, $modalID, message, buttons, title) {
        var self = this,
            $modal = $context.getElementById($modalID);
        self.$activeModal = $modal;

        self.updatePosition();
        // mark the main page as hidden
        self.$mainPage.setAttribute('aria-hidden', 'true');
        // insert an overlay to prevent clicking and make a visual change to indicate the main apge is not available
        self.$modalOverlay.classList.add('is-open');
        // open the modal, set state
        $modal.classList.add('is-open');
        $modal.setAttribute('aria-hidden', 'false');
        // prevent focus in any element outside modal
        self.$mainPage.addEventListener('focusin', function () {
            self.setFocusToFirstItemInModal($modal);
        });
        // store focused element before opening modal
        self.focusedElementBeforeModal = $context.querySelector(':focus');
        self.setFocusToFirstItemInModal($modal);
        // add key-bindings (tab/esc)
        $modal.addEventListener('keydown', function (event) {
            self.trapKeys($context, $modalID, event);
        });

        // set a dynamic message
        if (message) {
            $modal.querySelector('.js--message').innerHTML = '<p>' + message + '</p>';
        }

        if (title) {
            $modal.querySelector('.js--modal__title').innerHTML = title;
        }

        // set dynamic buttons
        if (buttons) {
            var $buttonTemplate = $modal.querySelector('.js--modal__dynamic-button-template');
            var $buttonWrap = $modal.querySelector('.js--modal__dynamic-button-wrap');

            // empty the wrapper
            while ($buttonWrap.firstChild) {
                $buttonWrap.removeChild($buttonWrap.firstChild);
            }

            // re-add the template
            $buttonWrap.appendChild($buttonTemplate);

            // append buttons, attach actions
            for (var i = 0; i < buttons.length; ++i) {
                var button = buttons[i];
                var $clone = $buttonTemplate.cloneNode(true);
                var $button = $clone.querySelector('.js--modal__dynamic-button');
                $button.innerHTML = button.text;
                $button.addEventListener('click', button.action);
                $clone.classList.remove('u-visuallyhidden');
                $buttonWrap.appendChild($clone);
            }
        }
    },

    trapKeys: function ($context, $modalID, event) {
        var self = this,
            $modal = $context.getElementById($modalID);

        // if escape pressed
        if (event.which === 27) {
            self.closeModal($context, $modalID);
        }

        // if tab or shift-tab pressed
        if (event.which === 9) {
            // get list of focusable items
            var focusableItems = $modal.querySelectorAll(self.focusableElementsString),
            // get currently focused item
                focusedItem = $context.querySelector(':focus');

            // get the number of focusable items
            var numberOfFocusableItems = focusableItems.length;

            // get the index of the currently focused item
            var focusedItemIndex = Array.prototype.indexOf.call(focusableItems, focusedItem);

            if (event.shiftKey) {
                //back tab
                // if focused on first item and user preses back-tab, go to the last focusable item
                if (focusedItemIndex === 0) {
                    focusableItems[numberOfFocusableItems - 1].focus();
                    event.preventDefault();
                }

            } else {
                //forward tab
                // if focused on the last item and user preses tab, go to the first focusable item
                if (focusedItemIndex === numberOfFocusableItems - 1) {
                    focusableItems[0].focus();
                    event.preventDefault();
                }
            }
        }
    },

    setFocusToFirstItemInModal: function ($modal) {
        var self = this;
        // set the focus to the first keyboard focusable item, but skip elements which have class="js--skip-initial-focus"
        var $focusableElements = $modal.querySelectorAll(self.focusableElementsString);
        for (var i = 0; i < $focusableElements.length; i++) {
            if (!$focusableElements[i].classList.contains('js--skip-initial-focus')) {
                $focusableElements[i].focus();
                return;
            }
        }
    },

    closeModal: function ($context, $modalID) {
        var self = this,
            $modal = $context.getElementById($modalID);

        if($modal === null){
            return;
        }

        self.$activeModal = null;

        // hide overlay
        self.$modalOverlay.classList.remove('is-open');
        // hide modal
        $modal.classList.remove('is-open');
        // set states
        $modal.setAttribute('aria-hidden', 'true');
        self.$mainPage.setAttribute('aria-hidden', 'false');
        // remove the listener which redirects tab keys in the main content area to the modal
        $context.removeEventListener('focusin', self.$mainPage);
        // set focus back to element that had it before the modal was opened
        if (self.focusedElementBeforeModal) {
            self.focusedElementBeforeModal.focus();
        }
    },

    updatePosition: function () {
        var self = this;
        if (self.$activeModal && oy.embedding.isEnabled) {
            window.requestAnimationFrame(function(){
                if (oy.embedding.child.parentViewportHeight <= oy.embedding.child.frameHeight) {
                    var modalCenterFromTop = (oy.embedding.child.parentScrollTop - oy.embedding.child.parentFramePosition) + (oy.embedding.child.parentViewportHeight/2);
                    var top = modalCenterFromTop - self.$activeModal.offsetHeight/2;
                    if (oy.embedding.child.parentScrollTop <= oy.embedding.child.parentFramePosition) {
                        top = oy.settings.space;
                    }
                    self.$activeModal.style.top = top + 'px';
                }
            });
        }
    }
};


window.addEventListener(oy.settings.embedScrollChangeName, function () {
    oy.modal.updatePosition();
}, false);


window.addEventListener('load', function () {
    oy.modal.init();
}, false);
